
import { Component, Vue } from 'vue-property-decorator'
import { ICustomer } from '@/modules/customer/types/customerTypes'
import { popUpRoute } from '@/services/utils/popupRoute'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import { customerEndpoints } from '@/modules/customer'
import PreviewAvatar from '@/stories/preview-avatar/PreviewAvatar.vue'

@Component({
  name: 'ResetPassword',
  components: {
    PreviewAvatar,
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class ResetPassword extends Vue {
  loading = false
  isResetBtnLoading = false
  customerData = {} as ICustomer
  data = {} as ICustomer

  /** submit the data to the desired endpoint. */
  async handleSubmit() {
    const { id } = parsePathQueryString(location.search)
    this.isResetBtnLoading = true
    if (id) {
      await customerEndpoints
        .setPassword(id)
        .then(() => {
          this.isResetBtnLoading = false
          this.closePopUp()
        })
        .finally(() => (this.isResetBtnLoading = false))
    }
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }

  created() {
    this.fetchRemoteData()
  }

  /** call given fetch data function */
  async fetchRemoteData() {
    const { id } = parsePathQueryString(location.search)
    this.loading = true
    try {
      if (id) {
        this.customerData = await customerEndpoints.get(id)
      }
    } catch (error) {
      throw new Error(`Failed to fetch form data. Due to ${error}`)
    } finally {
      this.loading = false
    }
  }
}
